import { isEmpty } from 'lodash'

// Util: Format passed price to return price with 2 default decimals
// ex. passed 10, return $10.00

export const formatPriceDecimals = (number, decimalsCounts = 2) => {
  if (isEmpty(number)) {
    return 'N/A'
  }
  const price = Number(number).toFixed(decimalsCounts)
  return `$${price}`
}
